import { Config } from 'common/api/models/Config';
import { Member } from 'common/api/models/Member';
import { isSuperuser } from 'common/utils/acl';
import { checkFeatureEnabled } from './checkFeatureEnabled';
import { Feature } from './Feature';

export function canViewBadges(flag: Feature, config?: Config, user?: Member) {
  return checkFeatureEnabled(flag, config) || (!!user && isSuperuser(user));
}



// WEBPACK FOOTER //
// ./src/common/features/canViewBadges.ts